define('uikit/collections/list',['require','exports','module','underscore','marionette','../channel','../mixins/component.mixin','../templates','../extra/size','../collections/container'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('../templates');
  var Size = require('../extra/size');
  var Container = require('../collections/container');

  var ListItem = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'item',

    attributes: {
      role: 'listitem',
    },

    tagName: function() {
      return this.getBoolOption('useListItem') ? 'li' : 'div';
    },

    template: Templates.UIKit['list.item'],

    options: {
      //Flag indicating whether a semantic <li> element should be rendered, or a generic div. <li> is rendered if true.
      useListItem: false,
      completed: false,
      link: false,
      header: '',
      text: '',
      icon: '',
      image: '',
      imageAlt: '',
      imageClass: '',
      useRightContainer: false,
      _index: -1,
    },

    forceUpdate: {
      link: true,
      header: true,
      text: true,
      icon: true,
      image: true,
      imageAlt: true,
      imageClass: true,
      useRightContainer: true,
      _index: true,
    },

    ui: {
      content: '> .content',
    },

    internalViews: {
      rightContainer: Container.extend({
        className: 'right floated',
      }),
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments),
        linkFormatter = this.getOption('linkFormatter');

      if (_.isFunction(linkFormatter)) {
        data.linkHref = linkFormatter.call(this, this.model);
        // if there is a link formatter then a link is assumed
        data.link = true;
      }

      return data;
    },

    updateAttributes: function() {
      this.addClass('completed', this.getBoolOption('completed'));
    },
  });

  var List = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'ui list',

    attributes: {
      role: 'list',
    },

    childView: ListItem,

    childViewEventPrefix: 'item',

    options: {
      bulleted: false,
      celled: false,
      divided: false,
      horizontal: false,
      inverted: false,
      ordered: false,
      relaxed: false,
      selection: false,
      padded: false,
      size: '',
    },

    tagName: function() {
      return this.getBoolOption('bulleted') ? 'ul' : this.getBoolOption('ordered') ? 'ol' : 'div';
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      // Override the Marionette buildChildView method to inject an option that will allow us to
      // determine if an <li> should be rendered for semantic correctness
      // PROTIP: if you're rendering <div>'s for a list of items, you suck. I'm looking at you "Semantic" UI.
      var shouldUseListItem = this.getBoolOption('bulleted') || this.getBoolOption('ordered');
      var options = _.extend({ model: child }, childViewOptions, { useListItem: shouldUseListItem });
      var view = new ChildViewClass(options);

      return view;
    },

    sizeOptionValues: _.values(Size),

    updateAttributes: function() {
      this.addClass('bulleted', this.getBoolOption('bulleted'));
      this.addClass('celled', this.getBoolOption('celled'));
      this.addClass('divided', this.getBoolOption('divided'));
      this.addClass('horizontal', this.getBoolOption('horizontal'));
      this.addClass('inverted', this.getBoolOption('inverted'));
      this.addClass('ordered', this.getBoolOption('ordered'));
      this.addClass('selection', this.getBoolOption('selection'));
      this.addClass('padded', this.getBoolOption('padded'));
      this.addClass(this.getOption('size'), this.getBoolOption('size'));

      var relaxed = _.isString(this.getOption('relaxed')) ? this.getOption('relaxed') + ' relaxed' : 'relaxed';
      this.addClass(relaxed, this.getBoolOption('relaxed'));
    },
  });

  channel.reply('list', function() {
    return List;
  });

  List.Item = ListItem;

  module.exports = List;
});

